module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/core-js/symbol/iterator.js
// module id = 622
// module chunks = 23 41